import { render, staticRenderFns } from "./VencenEnXDias.vue?vue&type=template&id=ea796c86&"
import script from "./VencenEnXDias.vue?vue&type=script&lang=js&"
export * from "./VencenEnXDias.vue?vue&type=script&lang=js&"
import style0 from "./VencenEnXDias.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea796c86')) {
      api.createRecord('ea796c86', component.options)
    } else {
      api.reload('ea796c86', component.options)
    }
    module.hot.accept("./VencenEnXDias.vue?vue&type=template&id=ea796c86&", function () {
      api.rerender('ea796c86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/dashboard/VencenEnXDias.vue"
export default component.exports